import React from "react";
import CartTabs from "./Cart/CartTabs";
import Basket from "./Cart/Basket/Basket";
import OrderProps from "./Cart/OrderProps/OrderProps";

class SaleOrderAjaxCart extends React.Component {
    render() {

        const {orderProps, basketItems ,wishList} = this.props;

        return (
            <div className="cart">

                <CartTabs
                    activeButton={"cart"}
                    cart={basketItems.length}
                    wishList={wishList.length}
                />

                <Basket
                    items={basketItems}
                    zeroPrice={this.props.zeroPrice}
                    deliveryPrice={this.props.deliveryPrice}
                    _onChangeBasketHandle={(value, index) => this.props._onChangeBasketHandle(value, index)}
                    _onRemoveBasketItem={id=>this.props._onRemoveBasketItem(id)}

                />

                <OrderProps
                    vars={orderProps}
                    zeroPrice={this.props.zeroPrice}
                    totalPrice={this.props.totalPrice + this.props.deliveryPrice}
                    deliveryPrice={this.props.deliveryPrice}
                    _onOrder={this.props._onOrder}
                />


            </div>
        );
    }
}

export default SaleOrderAjaxCart;